import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
  createCrashCourseSubject ({ state }, course) {
    let obj = course
    return new Promise((resolve, reject) => {
      axios.post('crash-course/create-crash-course-subject', obj)
        .then(response => {
          resolve(response.data)
          course = {}
        }).catch((err) => {
          reject(err)
        })
    })
  },
  // updateCourse ({ state }, course) {
  //   let obj = course
  //   return new Promise((resolve, reject) => {
  //     axios.post('course/updateCourse', obj)
  //       .then(response => {
  //         resolve(response.data)
  //         course = {}
  //       }).catch((err) => {
  //         reject(err)
  //       })
  //   })
  // },
  
  getCrashCourselist({ state, commit }) {
    axios.get('crash-course/get-all-crash-courses')
      .then(response => {
        state.crashCourseList = response.data
        console.log(response.data)
        commit('setCrashCourseList', response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  
  getCrashCourseSubjectlist({ state, commit }) {
    axios.get('crash-course/get-all-crash-course-subjects')
      .then(response => {
        state.crashCourseSubjectList = response.data
        console.log(response.data)
        commit('setCrashCourseSubjectList', response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },

}
